export function redirectToLoginPage() {
  const returnTo = encodeURIComponent(window.location.pathname + window.location.search);
  window.location.assign(`/sk/login?return-to=${returnTo}`);
}
